import { z } from "zod";

/**
 * Düğün bildirimleri (2026-10-18) — Telegram düğüne bağlanır; bir düğün sohbeti yalnız o düğünün olaylarını,
 * seçtiği türlerden alır. Admin sohbeti yalnız admini ilgilendirenleri (worker `lib/notifications`).
 * Tasarım: docs/plans/2026-10-18-telegram-dugun-bazli.md
 */
export const WEDDING_NOTIFICATION_KINDS = [
  "media_upload",
  "guest_join",
  "rsvp_submitted",
  "comment_created",
  "capacity",
] as const;
export type WeddingNotificationKind = (typeof WEDDING_NOTIFICATION_KINDS)[number];

/** Yeni bağlanan sohbetin varsayılan seçimi: hepsi (organizatör sonra daraltır). */
export const DEFAULT_WEDDING_NOTIFICATION_KINDS: readonly WeddingNotificationKind[] = WEDDING_NOTIFICATION_KINDS;

export const TELEGRAM_CHAT_TYPES = ["private", "group", "supergroup", "channel"] as const;
export type TelegramChatType = (typeof TELEGRAM_CHAT_TYPES)[number];

/** Düğüne bağlı bir Telegram sohbeti (panel kartı). */
export interface WeddingTelegramChat {
  id: string;
  chatType: TelegramChatType;
  /** Grup adı ya da kişinin adı. */
  title: string | null;
  username: string | null;
  events: WeddingNotificationKind[];
  linkedAt: string;
}

/** `GET …/w/:slug/telegram` */
export interface WeddingTelegramState {
  /** Migration 060 uygulandı mı (değilse bağlama kapalı). */
  available: boolean;
  /** Bot yapılandırıldı mı (TELEGRAM_BOT_TOKEN). */
  botConfigured: boolean;
  chats: WeddingTelegramChat[];
}

/** `POST …/w/:slug/telegram/link` — tek kullanımlık kod + iki bağlantı. */
export interface WeddingTelegramLinkCode {
  code: string;
  /** Kişisel sohbet: `https://t.me/<bot>?start=<kod>` */
  privateLink: string;
  /** Grup seçtirir: `https://t.me/<bot>?startgroup=<kod>` */
  groupLink: string;
  expiresAt: string;
}

export const weddingTelegramEventsSchema = z.object({
  events: z.array(z.enum(WEDDING_NOTIFICATION_KINDS)).max(WEDDING_NOTIFICATION_KINDS.length),
});

/** Bağlama kodu: Telegram `start` parametresi kuralına uyar (≤ 64, `A-Z a-z 0-9 _ -`); `w` öneki düğün kodu. */
export const TELEGRAM_LINK_CODE_RE = /^w[A-Za-z0-9]{16,40}$/;
